import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

function DriverInformationSection({
  values,
  handleChange,
  handleBlur,
  errors,
  setFieldValue,
  licenseClasses,
  raceClasses,
}) {
  const [juniorDisabled, setJuniorDisabled] = useState(false);
  const isFwdRwf = raceClasses.some(
    (rc) => rc.toLowerCase() === 'fwd' || rc.toLowerCase() === 'rwd'
  );
  useEffect(() => {
    if (values?.licenseClass === 'Junior') {
      setJuniorDisabled(false);
    } else {
      setJuniorDisabled(true);
    }
  }, [values?.licenseClass]);

  return (
    <>
      <Form.Group controlId="firstName" className="mt-2">
        <Form.Label>Förnamn</Form.Label>
        <Form.Control
          type="text"
          value={values?.firstName}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange förnamn"
          isInvalid={!!errors?.firstName}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.firstName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="lastName" className="mt-2">
        <Form.Label>Efternamn</Form.Label>
        <Form.Control
          type="text"
          value={values?.lastName}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange efternamn"
          isInvalid={!!errors?.lastName}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.lastName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Label className="mt-2 mb-0">Födelsedatum</Form.Label>
      <div className="d-flex justify-content-between">
        <Form.Group controlId="birthDate.year" className="me-2">
          <Form.Label>År</Form.Label>
          <Form.Control
            type="number"
            value={values?.birthDate?.year}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Ange år"
            isInvalid={!!errors?.birthDate?.year}
          />
          <Form.Control.Feedback type="invalid">
            {errors?.birthDate?.year}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="birthDate.month" className="me-2">
          <Form.Label>Månad</Form.Label>
          <Form.Control
            type="number"
            value={values?.birthDate?.month}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Ange månad"
            isInvalid={!!errors?.birthDate?.month}
          />
          <Form.Control.Feedback type="invalid">
            {errors?.birthDate?.month}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="birthDate.day" className="">
          <Form.Label>Dag</Form.Label>
          <Form.Control
            type="number"
            value={values?.birthDate?.day}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Ange dag"
            isInvalid={!!errors?.birthDate?.day}
          />
          <Form.Control.Feedback type="invalid">
            {errors?.birthDate?.day}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
      <Form.Group controlId="email" className="mt-2">
        <Form.Label>E-post</Form.Label>
        <Form.Control
          type="email"
          value={values?.email}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange e-post"
          isInvalid={!!errors?.email}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.email}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="phoneNumber" className="mt-2">
        <Form.Label>Telefonnummer</Form.Label>
        <Form.Control
          type="tel"
          value={values?.phoneNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange telefonnummer"
          isInvalid={!!errors?.phoneNumber}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.phoneNumber}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="street" className="mt-2">
        <Form.Label>Gatuadress</Form.Label>
        <Form.Control
          type="text"
          value={values?.street}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange gatuadress"
          isInvalid={!!errors?.street}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.street}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="zipCode" className="mt-2">
        <Form.Label>Postnummer</Form.Label>
        <Form.Control
          type="text"
          value={values?.zipCode}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange postnummer"
          isInvalid={!!errors?.zipCode}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.zipCode}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="city" className="mt-2">
        <Form.Label>Postort</Form.Label>
        <Form.Control
          type="text"
          value={values?.city}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange postort"
          isInvalid={!!errors?.city}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.city}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="nationality" className="mt-2">
        <Form.Label>Nationalitet</Form.Label>
        <Form.Select
          value={values?.nationality}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors?.nationality}
        >
          <option value="none" hidden>
            Välj ett land
          </option>
          <option value="Sverige">Sverige</option>
          <option value="Danmark">Danmark</option>
          <option value="Norge">Norge</option>
          <option value="Finland">Finland</option>
        </Form.Select>
        <Form.Control.Feedback type="invalid">
          {errors?.nationality}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="lotsId" className="mt-2">
        <Form.Label>Licensnummer</Form.Label>
        <Form.Control
          type="text"
          value={values?.lotsId}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange licensnummer"
          isInvalid={!!errors?.lotsId}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.lotsId}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="licenseClass" className="mt-2">
        <Form.Label>Licensklass</Form.Label>
        <div className="d-flex gap-4">
          {licenseClasses?.map((cls) => (
            <Form.Check
              key={cls}
              required
              name="licenseClass"
              type="radio"
              label={cls}
              id={`radio-license-${cls.toLowerCase()}`}
              feedback="Du måste välja en licensklass"
              feedbackType="invalid"
              value={cls}
              checked={values.licenseClass === cls}
              onChange={(e) => {
                setFieldValue('licenseClass', e.target.value);
                setFieldValue(
                  'raceClass',
                  e.target.value === 'Junior' ? 'Junior' : 'Senior'
                );
              }}
            />
          ))}
        </div>
      </Form.Group>
      <Form.Group controlId="raceClass" className="mt-2">
        <Form.Label>Tävlingsklass</Form.Label>
        <div className="d-flex gap-5">
          <div className="d-flex flex-column gap-2">
            <Form.Check
              required
              name="raceClass"
              type="radio"
              label="Junior"
              id="radio-junior"
              feedbackType="invalid"
              value="Junior"
              checked={values.raceClass === 'Junior'}
              disabled={juniorDisabled}
              onChange={(e) => setFieldValue('raceClass', e.target.value)}
              isInvalid={!!errors?.raceClass}
            />
            <Form.Check
              required
              name="raceClass"
              type="radio"
              label="Senior"
              id="radio-senior"
              feedbackType="invalid"
              value="Senior"
              checked={values.raceClass === 'Senior'}
              disabled={!juniorDisabled || isFwdRwf}
              onChange={(e) => setFieldValue('raceClass', e.target.value)}
              isInvalid={!!errors?.raceClass}
            />
            <Form.Check
              required
              name="raceClass"
              type="radio"
              label="FWD"
              id="radio-fwd"
              feedbackType="invalid"
              value="FWD"
              checked={values.raceClass === 'FWD'}
              disabled={!juniorDisabled || !isFwdRwf}
              onChange={(e) => setFieldValue('raceClass', e.target.value)}
              isInvalid={!!errors?.raceClass}
            />
          </div>
          <div className="d-flex flex-column gap-2">
            <Form.Check
              required
              name="raceClass"
              type="radio"
              label="Dam"
              id="radio-dam"
              feedbackType="invalid"
              value="Women"
              checked={values.raceClass === 'Women'}
              disabled={!juniorDisabled}
              onChange={(e) => setFieldValue('raceClass', e.target.value)}
              isInvalid={!!errors?.raceClass}
            />
            <Form.Check
              required
              name="raceClass"
              type="radio"
              label="Veteran"
              id="radio-veteran"
              feedbackType="invalid"
              value="Veteran"
              checked={values.raceClass === 'Veteran'}
              disabled={!juniorDisabled}
              onChange={(e) => setFieldValue('raceClass', e.target.value)}
              isInvalid={!!errors?.raceClass}
            />
            <Form.Check
              required
              name="raceClass"
              type="radio"
              label="RWD"
              id="radio-rwd"
              feedbackType="invalid"
              value="RWD"
              checked={values.raceClass === 'RWD'}
              disabled={!juniorDisabled || !isFwdRwf}
              onChange={(e) => setFieldValue('raceClass', e.target.value)}
              isInvalid={!!errors?.raceClass}
            />
          </div>
        </div>
        <span style={{ color: '#dc3545', fontSize: '0.875em' }}>
          {errors?.raceClass}
        </span>
      </Form.Group>
      <Form.Group controlId="clubAffiliation" className="mt-2">
        <Form.Label>Klubbtillhörighet</Form.Label>
        <Form.Control
          type="text"
          value={values?.clubAffiliation}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange klubbtillhörighet"
          isInvalid={!!errors?.clubAffiliation}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.clubAffiliation}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="miscellaneous" className="mt-2">
        <Form.Label>Övrig information (frivilligt)</Form.Label>
        <Form.Control
          type="text"
          value={values?.miscellaneous}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange övrig information"
          isInvalid={!!errors?.miscellaneous}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.miscellaneous}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
}

export default DriverInformationSection;
